import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "chevron-double-right_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.293 12 2 19.293l1.414 1.414L12.121 12 3.414 3.293 2 4.707 9.293 12Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m19.172 12-7.293 7.293 1.414 1.414L22 12l-8.707-8.707-1.414 1.414L19.172 12Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }